// extracted by mini-css-extract-plugin
export default {"tab":"fKF5ZrpJKr"};